import { render, staticRenderFns } from "./SelectedCoevaluatorRubric.vue?vue&type=template&id=20da448e&scoped=true"
import script from "./SelectedCoevaluatorRubric.vue?vue&type=script&lang=js"
export * from "./SelectedCoevaluatorRubric.vue?vue&type=script&lang=js"
import style0 from "./SelectedCoevaluatorRubric.vue?vue&type=style&index=0&id=20da448e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da448e",
  null
  
)

export default component.exports